import * as i0 from "@angular/core";
export class PlanDetailStore {
}
PlanDetailStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlanDetailStore_Factory() { return new PlanDetailStore(); }, token: PlanDetailStore, providedIn: "root" });
export var PlanDetailStoreKeys;
(function (PlanDetailStoreKeys) {
})(PlanDetailStoreKeys || (PlanDetailStoreKeys = {}));
